import type { JobPhoto } from '@/features/jobs/types/job-detail'

type JobPhotosSectionProps = {
  title: string
  ariaLabel: string
  photos: JobPhoto[]
  emptyMessage?: string
}

export const JobPhotosSection = ({
  title,
  ariaLabel,
  photos,
  emptyMessage,
}: JobPhotosSectionProps) => {
  const photosWithUrl = photos.filter((photo) => photo.url)

  return (
    <section className="flex flex-col gap-3">
      <h3 className="text-base font-semibold text-foreground">{title}</h3>
      {photosWithUrl.length > 0 ? (
        <ul
          aria-label={ariaLabel}
          className="grid grid-cols-2 gap-3 sm:grid-cols-3"
        >
          {photosWithUrl.map((photo) => (
            <li key={photo.id}>
              <img
                src={photo.url!}
                alt={`${title} ${photo.id}`}
                className="aspect-square w-full rounded-xl border border-outline/40 object-cover"
              />
            </li>
          ))}
        </ul>
      ) : (
        <div
          aria-label={ariaLabel}
          className="flex min-h-48 items-center justify-center rounded-xl border border-outline/40 bg-surface-muted/40 text-sm text-muted-foreground"
        >
          {emptyMessage}
        </div>
      )}
    </section>
  )
}
